// The metrics a chart panel can plot (§4.5), shared by the charts row and the
// customization drawer. Kept in its own dependency-free module so importing the
// list never pulls in the drawer — which imports recharts — letting the drawer
// lazy-load and stay off the eager bundle.
// Order follows the ticket (§4.5): protection metrics first, then the click
// counts (Ad clicks analyzed rides with them per the PO's 7-metric decision).
export const CHART_METRICS = [
	'Prevented ad waste',
	'Blocked sources',
	'Bad traffic rate',
	'Ad clicks analyzed',
	'Valid clicks',
	'Suspicious clicks',
	'Bad clicks'
]
